import enterpriseManage from "../../layout/enterpriseManage"
// 注意路由格式前缀一定要加/webenterpriseManage
export default {
    path: "/",
    component: enterpriseManage,
    redirect: "/webenterpriseManage/index",
    alwaysShow: true,
    name: "webenterpriseManage",
    children: [
        {
            path: "/webenterpriseManage/index",
            name: "index",
            meta: {
                parent:{
					path:'/webenterpriseManage/index',
					title:'应用',
					mosttitle:'应用中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'应用中心',index:0
            },
            component: () => import("@/webenterpriseManage/appCen/index")  
        },
        {
            path: "/webenterpriseManage/Order",
            name: "index",
            meta: {
                parent:{
					path:'/webenterpriseManage/Order',
					title:'订单',
					mosttitle:'我的订单'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'我的订单',index:1
            },
            component: () => import("@/webenterpriseManage/Order/index")  
        },
        {
            path: "/webenterpriseManage/teamSet",
            name: "teamSet",
            meta: {
                parent:{
					path:'/webenterpriseManage/teamSet',
					title:'团队',
					mosttitle:'团队设置'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'团队设置',index:2
            },
            component: () => import("@/webenterpriseManage/Team/teamSet/index")  
        },{
			path: "/webenterpriseManage/busInessDetail",
			name: "busInessDetail",
			meta: {
				parent:{
					path:'/webenterpriseManage/teamSet',
					title:'团队设置',
					mosttitle:'团队设置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'团队详情',index:2
			},
			component: () => import("@/webenterpriseManage/Team/teamSet/busInessDetail/index")
		},
        {
            path: "/webenterpriseManage/teamAdmin",
            name: "teamAdmin",
            meta: {
                parent:{
					path:'/webenterpriseManage/teamAdmin',
					title:'团队',
					mosttitle:'成员管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'成员管理',index:2
            },
            component: () => import("@/webenterpriseManage/Team/teamAdmin/index")  
        },{
			path: "/webenterpriseManage/addteamUser",
			name: "addteamUser",
			meta: {
				parent:{
					path:'/webenterpriseManage/teamAdmin',
					title:'成员管理',
					mosttitle:'成员管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增成员',index:2
			},
			component: () => import("@/webenterpriseManage/Team/teamAdmin/addteamUser/index")
		},{
			path: "/webenterpriseManage/editTeamUser",
			name: "editTeamUser",
			meta: {
				parent:{
					path:'/webenterpriseManage/teamAdmin',
					title:'成员管理',
					mosttitle:'成员管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'成员设置',index:2
			},
			component: () => import("@/webenterpriseManage/Team/teamAdmin/editTeamUser/index")
		},{
			path: "/webenterpriseManage/appSet",
			name: "appSet",
			meta: {
				parent:{
					path:'/webenterpriseManage/appSet',
					title:'应用权限设置',
					mosttitle:'应用权限设置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'应用权限设置',index:2
			},
			component: () => import("@/webenterpriseManage/Team/appSet/index")
		},
		{
			path: "/webenterpriseManage/AssignAuth",
			name: "AssignAuth",
			meta: {
				parent:{
					path:'/webenterpriseManage/appSet',
					title:'应用权限设置',
					mosttitle:'应用权限设置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'分配权限',index:2
			},
			component: () => import("@/webenterpriseManage/Team/appSet/AssignAuth/index")
		}
    ]
}
